import { useState } from 'react'
import bg from '../assets/bg2.webp'
import { LeaderboardPanel } from './LeaderboardPanel.tsx'
import { t } from '../i18n/translations.ts'

interface Props {
  onBack: () => void
}

type Period = 'daily' | 'weekly' | 'alltime'

/**
 * タイトル → みんなのナワバリ戦ランキング画面。
 *
 * daily / weekly / alltime のタブを切り替えて LeaderboardPanel を再マウントする
 * （`key={period}` で state をリセットし、fetch を再実行）。
 * 自分の順位は `LeaderboardPanel showMyEntry` 経由で `LeaderboardResponse.myEntry`
 * を表示する。
 */
export function RankingScreen({ onBack }: Props) {
  const [period, setPeriod] = useState<Period>('alltime')
  const tabs: { id: Period; label: string }[] = [
    { id: 'daily', label: t('today') },
    { id: 'weekly', label: t('weekly') },
    { id: 'alltime', label: t('alltime') },
  ]

  return (
    <div
      className="screen screen--ranking"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="ranking-overlay">
        <h2 className="ranking-title">🏆 {t('ranking')}</h2>

        <div className="ranking-tabs" role="tablist">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={period === tab.id}
              className={`ranking-tab ${period === tab.id ? 'ranking-tab--active' : ''}`}
              onClick={() => setPeriod(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="ranking-panel-wrapper">
          <LeaderboardPanel
            key={period}
            period={period}
            limit={20}
            showMyEntry
            scrollable
          />
        </div>

        <div className="ranking-buttons">
          <button className="btn btn--secondary" onClick={onBack}>
            {t('back')}
          </button>
        </div>
      </div>
    </div>
  )
}
